export default __webpack_public_path__ + "static/AirForceEmblem-cfec1a1566f3329b2d7d886da21f0156.jpg";